﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function myaimoparknavigation(context) {
  const toggleButton = context.querySelector('.myaimopark__nav__toggle');
  const selectionElement = context;
  const selectionElementLinks = selectionElement.querySelectorAll('a');

  function init() {
    toggleButton.addEventListener('click', function(event) {
      toggleButton.classList.toggle('active');
      selectionElement.classList.toggle('active');
      event.preventDefault();

      loopSelectionLinks(selectionElement.classList.contains('active'));

      if(toggleButton.classList.contains('active')) {
        setTimeout(function () {
          document.addEventListener("click", closeLanguageSelection);
        }, 250);
      } else {
        document.removeEventListener("click", closeLanguageSelection);
      }
    });
  }

	const loopSelectionLinks = function (isActive) {
    for (let i = 0; i < selectionElementLinks.length; i++) {
      const singleSelectionElementLink = selectionElementLinks[i];
      if (!isActive)
        singleSelectionElementLink.setAttribute('tabindex', '-1');
      else
        singleSelectionElementLink.removeAttribute('tabindex');
    }
	}

  const closeLanguageSelection = function(e) {
    if (e.target !== selectionElement && !isDescendant(selectionElement, e.target)) {
      toggleButton.classList.remove('active');
      selectionElement.classList.remove('active');
      loopSelectionLinks(false);

      document.removeEventListener("click", closeLanguageSelection);
    }
  }

  const isDescendant = function(parent, child) {
    var node = child.parentNode;
    while (node !== null) {
      if (node === parent)
          return true;

      node = node.parentNode;
    }
    return false;
  }

  return {
    init
  };
}

controller.add('myaimopark-navigation', myaimoparknavigation);
